import { Box, Typography } from "@mui/material"
import { useState } from "react";
import { useFormik } from 'formik';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { validationsSignUpSchema } from "../../../validations/validationSignUpSchema";

import BaseColorText from "../../BaseColorText";
import BaseButton from "../../BaseButton";
import InputPassword from "../../InputPassword";
import BaseInput from "../../BaseInput";
import HelpText from "../../HelpText";
import BaseLink from "../../BaseLink";

import { registerWithEmailAndPassword } from "../../../api-services/auth";
// import { showErrorToast } from "../../../utils/toast";
import { FIREBASE_AUTH_ERRORS } from "../../../constants/auth-errors";

/**
 * @param {Object} props
 */
const SignUpForm = ({ onNextStep }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState(null)
  
  const { errors, handleBlur, handleChange, handleSubmit, touched, values } =
    useFormik({
      validateOnBlur: true,
      initialValues: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      validationSchema: validationsSignUpSchema,
      onSubmit: async (values, { setSubmitting }) => {
        setIsLoading(true);
        registerWithEmailAndPassword('', values.email, values.password)
        .then((data) => {
          if (data) {
            onNextStep();
            setIsLoading(false);
          }
        })
        .catch(error => {
          setMessage(FIREBASE_AUTH_ERRORS?.[error.code] || error.message)
          // return showErrorToast({
          //   message: FIREBASE_AUTH_ERRORS?.[error.code] || error.message
          // })
        })
        .finally(() => {
          setIsLoading(false)
        })
      }
    });

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%'
    }}>
      <Box sx={{
        width: '100%',
        mt: '70px'
      }}>
        <Typography variant="h1">
          Set up your <BaseColorText isGradient gradientColor='#5A3BC7 30%, #5FB2EC 90%'>Account</BaseColorText>
        </Typography>
        <Box sx={{
          mt: '20px',
        }}>
          <form onSubmit={handleSubmit}>
            <BaseInput
              sx={{
                mt: '20px',
              }}
              fullWidth
              label='Email'
              name='email'
              type='email'
              placeholder='Enter your email'
              value={values.email || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={touched.email ? errors.email : ""}
              error={touched.email && Boolean(errors.email)}
              required
            />
            <InputPassword
              sx={{
                mt: '20px',
              }}
              fullWidth
              label='Password'
              name='password'
              placeholder='Enter your password'
              value={values.password || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={touched.password ? errors.password : ""}
              error={touched.password && Boolean(errors.password)}
              required
            />
            <InputPassword
              sx={{
                mt: '20px',
              }}
              fullWidth
              label='Confirm password'
              name='confirmPassword'
              placeholder='Confirm password'
              value={values.confirmPassword || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={touched.confirmPassword ? errors.confirmPassword : ""}
              error={touched.confirmPassword && Boolean(errors.confirmPassword)}
              required
            />
            {message && (
              <Typography variant="subText" color='primary.red'>{message}</Typography>
            )}
            <Box
              sx={{
                mt: { xs: '30px', sm: '50px' },
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <BaseButton
                disabled={Object.entries(errors).length !== 0}
                variant='contained'
                buttonType='primary'
                type='submit'
                loading={isLoading}
              >
                <Typography variant="body">
                  Continue
                </Typography>
                <ChevronRightIcon/>
              </BaseButton>
            </Box>
          </form>
        </Box>
      </Box>
      <Box
        sx={{
          mt: '80px'
        }}
      >
        <Box sx={{
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Typography
            variant="body"
            color='primary.darkGray'
          >
            Already have an account? {' '}
            <BaseLink to='/login' underline={true}>
              Click here to login
            </BaseLink>
          </Typography>
        </Box>
        <HelpText sx={{
          borderTop: '1px solid #ABB7C0',
          py: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: '4px'
        }}>
        </HelpText>
      </Box>
    </Box>
  )
}

export default SignUpForm;